import { Box, DialogActions, DialogContent, Divider, Modal, ModalDialog, Stack, Typography } from '@mui/joy';
import React, { FC } from 'react';
import { RiPrinterFill } from 'react-icons/ri';
import QRCode from 'react-qr-code';

import { useFetchOrganizationOfCurrentUser } from '@MP/shared/api/hooks/auth';
import { RectangleButton } from '@MP/shared/components/Button';

const NewPatientQRDialog: FC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => {
  const [printOpen, setPrintOpen] = React.useState(false);
  const { data: org } = useFetchOrganizationOfCurrentUser();

  const qrUrl = org
    ? `${window.location.protocol}//${window.location.host}/m/create-subject?orgId=${org.id}&secretKey=${org.id}_${org.code}`
    : '';

  const handlePrint = () => {
    setPrintOpen(true);
  };

  React.useEffect(() => {
    if (printOpen) {
      window.print();
    }
  }, [printOpen]);

  React.useEffect(() => {
    const handleAfterPrint = () => {
      setPrintOpen(false);
    };

    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, []);

  if (!qrUrl) {
    return <></>;
  }

  return (
    <>
      {printOpen && (
        <Stack
          className="print-qr-container"
          alignItems={'center'}
          justifyContent={'center'}
          position={'fixed'}
          left={0}
          top={0}
          bottom={0}
          right={0}
          spacing={'140px'}
          visibility={'hidden'}>
          <Stack spacing={'12px'} alignItems={'center'}>
            <Typography sx={{ fontSize: 46, color: '#333' }} fontWeight={600}>
              환자 추가 QR 코드
            </Typography>
            <Typography sx={{ fontSize: 30, color: '#333' }}>
              휴대전화 카메라로 QR 촬영해서 환자를 추가 해주세요.
            </Typography>
          </Stack>
          <QRCode value={qrUrl} size={500} />
        </Stack>
      )}
      <Modal open={open}>
        <ModalDialog sx={{ gap: '16px' }}>
          <Box>
            <Typography level="h4" fontWeight={600}>
              환자 추가 QR 코드
            </Typography>
            <Typography level="body-sm">휴대전화 카메라로 QR 촬영해서 환자를 추가 해주세요.</Typography>
            <Typography level="body-sm">
              환자 추가 QR 코드는 항상 동일하기 때문에, 출력해서 사용할 수 있습니다.
            </Typography>
          </Box>

          <DialogContent sx={{ width: '500px' }}>
            <Stack alignItems={'center'}>
              <QRCode value={qrUrl} />
            </Stack>
          </DialogContent>
          <Divider />
          <DialogActions sx={{ pt: 0 }}>
            <RectangleButton onClick={onClose}>확인</RectangleButton>
            <RectangleButton variant="outlined" onClick={handlePrint} startDecorator={<RiPrinterFill />}>
              출력하기
            </RectangleButton>
          </DialogActions>
        </ModalDialog>
      </Modal>
    </>
  );
};

export default NewPatientQRDialog;
